import { render, staticRenderFns } from "./gm.vue?vue&type=template&id=10d6140b"
import script from "./gm.vue?vue&type=script&lang=js"
export * from "./gm.vue?vue&type=script&lang=js"
import style0 from "./gm.vue?vue&type=style&index=0&id=10d6140b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports